import { isValidEmail } from "shared/utils/isValidEmail";

export const transformLinkUri = (uri: string): string => {
  if (isValidEmail(uri)) {
    return uri;
  } else if (/^https?:/.test(uri)) {
    return uri;
  } else {
    return `http://${uri}`;
  }
};
